module.exports = __webpack_public_path__ + "img/logo11.c1a8a6b9.png";